
// import { fetchScrapRecords, selectScrapRecord, resetCurrentScrapRecord } from '../../actions/scrapRecords_actions';
import { reduxForm, formValueSelector } from 'redux-form';

import { fetchPutAwayDetail, createPutAway, editPutAway, fetchPutAway, resetCurrentPutAway, fetchBinList, createBins, resetCurrentWarehouseReceive, selectWarehouseReceive } from '../../actions/putAway_actions';
import { fetchReceiveHistory, fetchReceiveHistoryDetail, fetchAllReceiveHistoryDetail } from '../../actions/receive_actions';
import { fetchZoneDetail } from '../../actions/zones_actions';
import { connect } from 'react-redux';
import { fetchWarehouses } from '../../actions/warehouses_actions';
import { fetchWarehouseDetail } from '../../actions/warehouses_actions';

import InboundForm from '../../components/Inventories/inboundForm'

let inboundForm = reduxForm({
    form: 'inboundForm',
})(InboundForm);

const selector = formValueSelector('inboundForm');

function mapStateToProps(state) {
    const zone_id = selector(state, 'Zone_id');
    const Default_Warehouse_id = selector(state, 'Default_Warehouse_id');
    const Default_WarehouseZone_id = selector(state, 'Default_WarehouseZone_id');
    return {
        Default_Warehouse_id,
        Default_WarehouseZone_id,
        zone_id: zone_id,
        putAway: state.putAway.all,
        isLoading: state.putAway.isLoading,
        error: state.putAway.error,
        receiveHistory: state.receives.fetchedReceiveHistory,
        allReceiveHistoryDetail: state.receives.fetchedAllReceiveHistoryDetail,
        receiveHistoryDetail: state.receives.fetchedReceiveHistoryDetail,
        currentPutAway: state.putAway.currentPutAway,
        currentPutAwayDetail : state.putAway.currentPutAwayDetail,
        currentZoneDetail : state.zones.currentZoneDetail,
        bins: state.zones.bins,
        detailIsLoading: state.zones.detailIsLoading,
        detailError: state.zones.detailError,
        binList: state.putAway.fetchedBinList,
        warehouses: state.warehouses.all,
        currentWarehouseDetail: state.warehouses.currentWarehouseDetail
    };
}

export default connect(mapStateToProps, { fetchWarehouses, fetchWarehouseDetail, resetCurrentWarehouseReceive, selectWarehouseReceive, createBins, fetchPutAwayDetail, createPutAway, editPutAway, fetchReceiveHistoryDetail, fetchAllReceiveHistoryDetail, fetchReceiveHistory, fetchPutAway, resetCurrentPutAway, fetchZoneDetail, fetchBinList })(inboundForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inboundForm.jsx